import { request } from '@koi-design/vix-tools';
import { prefixApi } from './urls';
// 获取企业微信 Ticket
export interface GetWorkWxTicketParams {
  corpId: string; // 企业微信企业ID
  url: string; // 当前页面URL
}

export interface GetWorkWxAgentTicketParams {
  corpId: string; // 企业微信企业ID
  url: string; // 当前页面URL
}

// 获取企业微信Ticket
export const getWorkWxTicketApi = (params: GetWorkWxTicketParams) => {
  return request({
    url: `${prefixApi}/wxAuth/getWorkWxTicket`,
    method: 'POST',
    data: params
  });
};

// 获取企业微信 Agent Ticket
export const getWorkWxAgentTicketApi = (params: GetWorkWxAgentTicketParams) => {
  return request({
    url: `${prefixApi}/wxAuth/getWorkWxAgentTicket`,
    method: 'POST',
    data: params
  });
};
